/**
 * Construit les données de budget pour le template Word.
 * Tous les calculs sont faits ici, les balises sont prêtes à remplir le template.
 * Utilisé par la Convention d'Étude ET par le Devis (données communes).
 */

export function construireBudgetTemplate(formData) {
  const { phases, fraisDossier, conditionsPaiement } = formData.commun;

  // ── 1. PHASES AVEC MONTANTS ────────────────────────────────
  const phasesAvecMontants = phases.map((p, index) => ({
    numeroPhase: index + 1,
    designationPhase: p.designation,
    nombreJehPhase: parseFloat(p.nombreJeh) || 0,
    descriptionPhase: p.description_phase ?? '',
    prixUnitairePhase: formatCurrency(parseFloat(p.prixUnitaire) || 0),
    montantHTPhase: formatCurrency(
      (parseFloat(p.nombreJeh) || 0) * (parseFloat(p.prixUnitaire) || 0)
    ),
  }));

  // ── 2. FRAIS DOSSIER ────────────────────────────────────────
  const montantFraisDossierRaw = parseFloat(fraisDossier) || 0;
  const montantFraisDossier = formatCurrency(montantFraisDossierRaw);

  // ── 3. TOTAUX DU BUDGET ─────────────────────────────────────
  const sousTotalPhaseRaw = phasesAvecMontants.reduce(
    (acc, p) => acc + parseFloat(deformatCurrency(p.montantHTPhase)),
    0
  );
  const sousTotalPhase = formatCurrency(sousTotalPhaseRaw);

  const sousTotalHTRaw = sousTotalPhaseRaw + montantFraisDossierRaw;
  const sousTotalHT = formatCurrency(sousTotalHTRaw);

  const tauxTVANum = 20;
  const montantTVARaw = sousTotalHTRaw * (tauxTVANum / 100);
  const montantTVA = formatCurrency(montantTVARaw);

  const totalTTCRaw = sousTotalHTRaw + montantTVARaw;
  const totalTTC = formatCurrency(totalTTCRaw);

  // ── 4. MODALITÉS DE PAIEMENT ────────────────────────────────
  const pourcentageSignatureNum = parseInt(conditionsPaiement.pctSignature, 10) || 55;
  const pourcentageLivrableNum = parseInt(conditionsPaiement.pctLivrable, 10) || 45;
  const pourcentageSignature = `${pourcentageSignatureNum}`;
  const pourcentageLivrable = `${pourcentageLivrableNum}`;
  const nombreJehTotal = Math.round(phasesAvecMontants.reduce((acc, p) => acc + p.nombreJehPhase, 0));

  const montantHTSignatureRaw = sousTotalHTRaw * (pourcentageSignatureNum / 100);
  const montantHTLivrableRaw = sousTotalHTRaw * (pourcentageLivrableNum / 100);
  const montantHTSignature = formatCurrency(montantHTSignatureRaw);
  const montantHTLivrable = formatCurrency(montantHTLivrableRaw);

  const montantTTCSignatureRaw = montantHTSignatureRaw + (montantTVARaw * (pourcentageSignatureNum / 100));
  const montantTTCLivrableRaw = montantHTLivrableRaw + (montantTVARaw * (pourcentageLivrableNum / 100));
  const montantTTCSignature = formatCurrency(montantTTCSignatureRaw);
  const montantTTCLivrable = formatCurrency(montantTTCLivrableRaw);

  return {
    phases: phasesAvecMontants,
    montantFraisDossier,
    sousTotalPhase,
    sousTotalHT,
    montantTVA,
    totalTTC,
    tauxTVA: `${tauxTVANum}%`,
    pourcentageSignature,
    pourcentageLivrable,
    nombreJehTotal,
    montantHTSignature,
    montantHTLivrable,
    montantTTCSignature,
    montantTTCLivrable,
  };
}

function formatCurrency(num) {
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

function deformatCurrency(str) {
  if (!str) return 0;
  return parseFloat(str.replace(/\s/g, '').replace(',', '.'));
}
